import React, { FC, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import FhirLoader from '../../../../FhirLoader'
import { ConditionBundle } from '../../../../../types/FHIRTypes/Bundle'
import useFhirConfig from '../../../../../hooks/admin/useFhirConfig'
import { Condition as FHIRCondition } from '@teschglobal/tg-fhir-react-components/dist/types'
import { Condition } from '@teschglobal/tg-fhir-react-components'
import { UseQueryResult } from 'react-query'
import useFhirResourceById from '../../../../../hooks/admin/useFhirResourceById'

type ConditionDetailProps = {
    conditionDetailId: string | undefined;
}

const ConditionDetail: FC<ConditionDetailProps> = ({ conditionDetailId}) => {
    const { patientAccessFhirConfig } = useFhirConfig()
      const {
    data: condition,
    isFetching,
    isLoading,
    isError
  }: UseQueryResult<FHIRCondition, Error> =
    useFhirResourceById('Patient Access', conditionDetailId || '', 'Condition')

  if (isFetching || isLoading) {
    return <FhirLoader />
  }

  if (!condition || isError) {
    return <div className='text-center' role='status' aria-live='polite' aria-atomic='true'>Not Found</div>
  }

    return (
        <div>
            <section>
                <Condition
                    data={condition}
                    fhirApiConfig={patientAccessFhirConfig}
                />
            </section>
        </div>
    )
}

export default ConditionDetail